import { COMPANY_NAME, EXCHANGE_COMPANY_NAME } from "../../Constants/TableFilter.constants";
import GenericMappingTable from "../ApiSettings/Index";

const CompanyNameMapping: React.FC = () => (
  <GenericMappingTable
    pageTitle="Company Name Mapping"
    entityLabel={EXCHANGE_COMPANY_NAME}
    entityFieldName="API_broker_name"
    selectLabel={COMPANY_NAME}
    selectFieldName="broker"
    selectDisplayFieldName="broker_name"
    dataApiUrl="/paper-app/api-broker-settings/"
    optionsApiUrl="/paper-app/api-broker-settings-brokers/"
    queryKeyData="api-broker-settings"
    queryKeyOptions="api-broker-list"
  />
);

export default CompanyNameMapping;